export function parseStore(storeQuery) {
  const data = (storeQuery.data && storeQuery.data()) || storeQuery;
  return {
    code: data.code,
    logo: data.logo,
    id: storeQuery.id,
    status: data.status,
    arctic: data.arctic,
    parking: data.parking,
    is_valid: data.is_valid,
    retailerRef: data.retailer,
    location_id: data.location_id,
    has_time_windows: data.has_time_windows,
    lat: data.coords && data.coords.latitude,
    lng: data.coords && data.coords.longitude,
    postcode: data.address && data.address.postcode,
    formatted_address: data.address && data.address.street,
    updatedAt: data.last_updated && data.last_updated.seconds,
  };
}

export function parseRetailer(query) {
  const data = (query.data && query.data()) || query;
  return {
    name: data.name,
    id: query.id,
  };
}

export function parsePallets(palletQuery) {
  const data = (palletQuery.data && palletQuery.data()) || palletQuery;

  return {
    id: palletQuery.id,
    isTopable: data.is_topable,
    stackable: data.is_stackable,
    purchaseOrderRef: data.po_ref,
    supplierRef: data.supplier_ref,
    emptyWeight: data.empty_weight,
    palletPrice: data.pallet_price,
    aggregateWeight: data.agg_weight,
    externalDimension: data.externalDimension,
    topperFillPercentage: data.topper_fill_percentage,
    products: data.products
    && data.products.map(
      /* eslint-disable-next-line no-use-before-define */
      (product) => parseProducts(
        { ...product.product_data, quantity: product.quantity, id: product.product_id.id },
      ),
    ),
  };
}

export function parseProducts(productQuery) {
  const data = (productQuery.data && productQuery.data()) || productQuery;

  return {
    id: productQuery.id,
    weight: data.weight,
    quantity: data.quantity,
    isTopper: data.is_topper,
    isTopable: data.is_topable,
    supplierRef: data.supplier,
    description: data.description,
    retailerCode: data.retailer_code,
    unitsOnPallet: data.units_on_pallet,
    pallet: parsePallets(data.pallet || {}),
    vendorReferenceCode: data.vendor_reference_code,
  };
}

export function parseDepot(depotQuery) {
  const data = (depotQuery.data && depotQuery.data()) || depotQuery;
  return {
    ...data,
    id: depotQuery.id,
    formatted_address: [
      data.address.city,
      data.address.street,
      data.address.country,
    ].join(', '),
    lat: data.coords && data.coords.latitude,
    lng: data.coords && data.coords.longitude,
    postcode: data.address && data.address.postcode,
  };
}

export function parseOrder(storeQuery) {
  const data = (storeQuery.data && storeQuery.data()) || storeQuery;
  return {
    palletSize: 1,
    status: data.status,
    storeRef: data.store,
    orderId: storeQuery.id,
    supplierRef: data.supplier,
    pallets: data.number_of_pallets,
    purchaseOrderRef: data.purchase_order,
    assigned_haulier: data.assigned_haulier,
    ...parseStore(data.store ? { ...data.store_data, id: data.store.id } : {}),
  };
}

export function parsePurchaseOrder(purchaseOrderQuery) {
  const data = (purchaseOrderQuery.data && purchaseOrderQuery.data()) || purchaseOrderQuery;

  return {
    status: data.status,
    retailer: data.retailer,
    storeRef: data.store_ref,
    po_number: data.po_number,
    id: purchaseOrderQuery.id,
    supplierRef: data.supplier,
    isInvalid: data.po_invalid,
    is_archived: data.is_archived,
    is_cancelled: data.is_cancelled,
    purchaseOrderBlockRef: data.po_block,
    invalidReasons: data.invalidity_reasons,
    poDate: data.po_date && data.po_date.seconds,
    createdAt: data.created_at && data.created_at.seconds,
    deliveryDate: data.delivery_date && data.delivery_date.seconds,
    store: parseStore(data.store_ref ? { ...data.store_data, id: data.store_ref.id } : {}),
  };
}

export function parseJob(query) {
  const data = (query.data && query.data()) || query;
  return {
    id: query.id,
    routeRef: data.route,
    purchaseOrderRef: data.po,
    choosenTimeWindow: data.chosen_time_window,
    deliveryRequestRef: data.delivery_request,
    createdAt: data.created_at && data.created_at.seconds,
    numberOfPalletsDelivered: data.number_of_pallets_delivered,
    choosenDate: data.choosen_date && data.choosen_date.seconds,
    deliveryTime: data.chosen_time_window && data.chosen_time_window.start,
    purchaseOrder: parsePurchaseOrder(data.po ? { ...data.po_data, id: data.po.id } : {}),
    pallets: data.pallets
    && data.pallets.map(
      /* eslint-disable-next-line no-use-before-define */
      (pallet) => parsePallets(
        { ...pallet.po_pallet_data, id: pallet.po_pallet_ref.id },
      ),
    ),
  };
}

export function parsePurchaseOrderLines(query) {
  const data = (query.data && query.data()) || query;
  return {
    id: query.id,
    ean: data.ean,
    storeRef: data.store,
    supplierRef: data.supplier,
    productRef: data.product_ref,
    purchaseOrderRef: data.po_ref,
    isInvalid: data.po_line_invalid,
    purchaseOrderBlockRef: data.po_block,
    productQuantity: data.product_quantity,
    numberOfPallets: data.number_of_pallets,
    vendorReferenceCode: data.vendor_reference_code,
    createdAt: data.created_at && data.created_at.seconds,
    store: parseStore(data.store ? { ...data.store_data, id: data.store.id } : {}),
    purchaseOrder: parsePurchaseOrder(
      data.po_ref ? { ...data.po_data, id: data.po_ref.id } : {},
    ),
    product: parseProducts(
      data.product_ref
        ? { ...data.product_data, id: data.product_ref.id }
        : {},
    ),
  };
}

export function parseRoute(routeQuery) {
  const data = (routeQuery.data && routeQuery.data()) || routeQuery;
  return {
    path: data.path,
    id: routeQuery.id,
    status: data.status,
    routeId: data.external_id,
    supplierRef: data.supplier,
    isFeasible: data.is_feasible,
    date: data.date && data.date.seconds,
    purchaseOrderRef: data.purchase_order,
    total_pallet_cost: data.total_pallet_cost,
    deliveryRequestRef: data.delivery_request,
    createdAt: data.created_at && data.created_at.seconds,
    total_delivered_pallets: data.total_delivered_pallets,
  };
}

export function parseDeliveryRequest(query) {
  const data = (query.data && query.data()) || query;
  return {
    id: query.id,
    status: data.status,
    deliveryRequestId: data.external_id,
    numberOfRoutes: data.number_of_routes,
    createdAt: data.created_at && data.created_at.seconds,
    numberOfCompletedRoutes: data.number_of_routes_completed,
  };
}
